<template>
  <div class="concact">
    <div class="container">
      <div class="text">
        <div class="title">
          {{ $t('resources.form.title') }}
        </div>
        <p class="desc">
          {{ $t('resources.form.subTitle') }}
        </p>
      </div>
      <el-form ref="formData" inline :show-message="false" :status-icon="true" :model="formData" :rules="rules" :hide-required-asterisk="true" class="message-form">
        <img class="icon" v-lazy-load data-src="~assets/images/resources/form_icon.png">
        <el-form-item prop="firstName">
          <el-input v-model="formData.firstName" :placeholder="this.$t('home.getNotifiedConfig.form.firstName')" />
        </el-form-item>
        <el-form-item prop="lastName">
          <el-input v-model="formData.lastName" :placeholder="this.$t('home.getNotifiedConfig.form.lastName')" />
        </el-form-item>
        <el-form-item prop="email">
          <el-input v-model="formData.email" :placeholder="this.$t('home.getNotifiedConfig.form.email')" />
        </el-form-item>

        <div class="button-wrapper">
          <el-button
            class="button button-normal get-button font-bold"
            :loading="loading"
            @click="handleSubmit"
          >
            {{ $t('resources.form.submitBtn') }}
          </el-button>
          <p class="tip">
            {{ $t('resources.form.tip') }}
          </p>
        </div>
      </el-form>
      <div v-if="$t('resources.form.leadText')" class="more">
        <div class="lead">
          {{ $t('resources.form.leadText') }}
        </div>
        <div v-if="$t('resources.form.leadBtn')" class="btn button button-small button-primary-white">
          <a :href="facebookUrl">{{ $t('resources.form.leadBtn') }}</a>
        </div>
      </div>
    </div>
    <div v-if="$t('resources.form.toolsList').length" class="bottom-span">
      <div class="lead">
        Contact us
      </div>
      <div class="contact-wrap">
        <div v-if="$t('resources.form.toolsList').includes('facebook')" class="contact-method facebook">
          <img v-lazy-load data-src="~assets/images/resources/facebook.png">  <a :href="facebookUrl">Facebook</a>
        </div>
        <div v-if="$t('resources.form.toolsList').includes('wechat')" class="contact-method wechat">
          <img v-lazy-load data-src="~assets/images/resources/wechat.png">   Wechat
          <div class="pop-img">
            <img v-if="wechatQrcode" v-lazy-load :data-src="wechatQrcode" alt="">
          </div>
        </div>
        <div v-if="$t('resources.form.toolsList').includes('whatsapp')" class="contact-method whatsapp">
          <img v-lazy-load data-src="~assets/images/resources/whatsapp.png"> WhatsApp
          <div class="pop-img">
            <img v-if="whatsappQrcode" v-lazy-load :data-src="whatsappQrcode" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { oneApi } from 'config/api';

import { elementOfArray } from 'common/utils';

export default {
  data() {
    return {
      tools: this.$t('common.rightTools'),
      loading: false,
      wechatQrcode: this.$t('common.follow.wechatQrcode'),
      whatsappQrcode: this.$t('common.follow.whatsappQrcode'),
      facebookUrl: this.$t('common.follow.facebookUrl'),
      pageConfig: this.$t('courses.fillIinformation'),
      formData: {
        name: '',
        email: '',
      },
      rules: {

        firstName: [
          { required: true, trigger: 'blur' },
        ],
        lastName: [
          { required: true, trigger: 'blur' },
        ],
        email: [
          { required: true, trigger: 'blur' },
          { type: 'email', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
  },
  methods: {
    code(val) {
      return elementOfArray('type', val, this.tools).link
    },
    infoSubmit() {
      const data = { previous_source: 'free resources' }
      this.Sensors.track('lead_card_submit', data)
    },

    async save(callback) {
      const data = {
        firstName: this.formData.firstName,
        lastName: this.formData.lastName,
        email: this.formData.email,
        sourceCode: 'website',
        mediaCode: 'pc_lead',
      }
      // 打开Loading
      this.loading = true;
      // 保存数据接口
      const res = await this.$axios.post(oneApi.addSaleslead, data, { rewritePostBody: true });
      // 关闭Loading
      this.loading = false;

      // 业务异常阻断
      if (Number(res.code) !== 0) {
        this.infoSubmit()
        return this.$ElMessage({
          message: res.msg,
          type: 'warning',
        });
      }
      this.infoSubmit()
      // 清空表单
      this.$refs.formData.resetFields();

      // 执行回调
      if (callback) { callback() }
      return res
    },
    handleSubmit() {
      this.$refs.formData.validate((valid) => {
        if (!valid) {
          return false;
        }
        this.save(() => this.$ElMessage({
          type: 'success',
          message: this.$t('home.getNotifiedConfig.success'),
        }));

        return true;
      });
    },
  },
}
</script>
<style lang="scss" scoped>
.concact {
  float: right;
  top: 120px;
  position: sticky;
  right: 0;

  .bottom-span {
    display: flex;
    align-items: center;
    margin-top: -10px;
    padding: 22px 12px 10px 12px;
    z-index: -1;
    width: 360px;
    background: #f3f7ff;
    border-radius: 0 0 16px 16px;
    justify-content: space-between;

    .lead {
      width: 79px;
      white-space: nowrap;
      height: 19px;
      font-size: 16px;
      font-weight: 500;
      color: var(--txt-color-lv3);
      line-height: 19px;
      margin-right: 9px;
    }

    .contact-wrap {
      display: flex;
    }

    .contact-method {
      position: relative;
      background: #fff;
      border-radius: 8px;
      padding: 6px 8px 6px 6px;
      font-size: 16px;
      font-weight: 500;
      line-height: 19px;
      margin-right: 8px;
      display: flex;
      align-items: center;

      >img {
        width: 24px;
        height: 24px;
        margin-right: 4px;
      }

      &.facebook {
        a {
          color: #1978f2;
        }
      }

      .pop-img {
        display: none;
        position: absolute;
        bottom: 58px;
        right: 10px;
        width: 160px;
        height: 160px;
        background: #f4f6fa;
        overflow: hidden;
        border-radius: 8px;
        border: 3px  #f4f6fa solid;
        z-index: 2;

        img {
          width: 100%;
          height: 100%;
        }
      }

      &.wechat {
        color: #06c662;
        cursor: pointer;
        padding-right: 18px;

        &:hover {
          .pop-img {
            display: block;
          }
        }
      }

      &.whatsapp {
        margin-right: 0;
        color: #06c662;
        cursor: pointer;
        padding-right: 18px;

        &:hover {
          .pop-img {
            display: block;
          }
        }
      }

      &:nth-last-child(1) {
        margin-right: 0;
      }
    }
  }

  .container {
    width: 360px;
    background: #3370ff;
    border-radius: 12px;
    padding: 20px 10px;
    position: relative;
    z-index: 1;

    .more {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .lead {
        width: 190px;
        padding-left: 10px;
        font-size: 16px;
        font-weight: 500;
        color: #fff;
        line-height: 19px;

        &:only-of-type {
          width: 100%;
        }
      }

      .btn {
        margin-left: 10px;
        height: 40px;
        padding: 7px 20px 6px;
        white-space: nowrap;
        width: fit-content;

        &:hover {
          border: none;
        }

        a {
          color: var(--txt-color-link);
        }
      }
    }
  }

  .text {
    padding: 17px 10px;
    text-align: center;
  }

  .title {
    font-size: 24px;
    font-weight: 600;
    color: #fff;
    line-height: 29px;
  }

  .desc {
    font-size: 14px;
    font-weight: 500;
    color: #f3f7ff;
    line-height: 16px;
    margin-top: 12px;
  }

  .message-form {
    background: #fff;
    border-radius: 10px;
    padding: 20px 10px;
    position: relative;
    margin-top: 40px;

    >.icon {
      width: 76px;
      height: 78px;
      position: absolute;
      z-index: 2;
      top: -61px;
      right: 0;
    }

    .el-form-item {
      margin-bottom: 10px;
      width: 100%;

      /deep/.el-form-item__content {
        width: 100%;

        .el-input__inner {
          height: 48px;
          border-radius: 24px;
          border: 2px solid #f8f9fa;
          font-size: 14px;
          font-weight: 500;
          color: var(--txt-color-lv1);
        }
      }

      &:nth-last-child(1) {
        margin-bottom: 0;
      }
    }

    .get-button {
      min-width: 218px;
      font-size: 16px;
      font-weight: 600;
      color: #fff;
      line-height: 19px;
      margin: 10px auto 20px;
      background: var(--txt-color-link);
      border-radius: 24px;
    }

    .tip {
      padding: 0 10px;
      font-size: 10px;
      font-weight: 500;
      color: var(--txt-color-lv2);
      letter-spacing: 0.22px;
      line-height: 12px;
    }
  }
}
</style>
